export class TableRow {

  [key:string]: string | number;



}
